module.exports = __webpack_public_path__ + "static/zariel-eb0ccee977b01c7339e3e88347a9744c.png";